import { render, staticRenderFns } from "./TicketDetailDrawer.vue?vue&type=template&id=cce70b20"
import script from "./TicketDetailDrawer.vue?vue&type=script&lang=js"
export * from "./TicketDetailDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports